function getImg(itemName) {
    if (itemName === "水龙头") {
        return require("../../../assets/repair/img-1.png");
    }
    else if (itemName === "窗帘") {
        return require("../../../assets/repair/img-2.png");
    }
    else if (itemName === "门锁") {
        return require("../../../assets/repair/img-3.png");
    }
    else if (itemName === "床") {
        return require("../../../assets/repair/img-4.png");
    }
    else if (itemName === "沙发") {
        return require("../../../assets/repair/img-5.png");
    }
    else if (itemName === "柜子") {
        return require("../../../assets/repair/img-6.png");
    }
    else if (itemName === "洗脸盆") {
        return require("../../../assets/repair/img-7.png");
    }
    else if (itemName === "下水管") {
        return require("../../../assets/repair/img-8.png");
    }
    else if (itemName === "晾衣架") {
        return require("../../../assets/repair/img-9.png");
    }
    else if (itemName === "灯") {
        return require("../../../assets/repair/img-10.png");
    }
    else if (itemName === "花洒") {
        return require("../../../assets/repair/img-11.png");
    }
    else if (itemName === "门窗") {
        return require("../../../assets/repair/img-13.png");
    }
    else if (itemName === "网络") {
        return require("../../../assets/repair/img-14.png");
    }
    else if (itemName === "洗衣机") {
        return require("../../../assets/repair/img-15.png");
    }
    else if (itemName === "电视") {
        return require("../../../assets/repair/img-16.png");
    }
    else if (itemName === "马桶") {
        return require("../../../assets/repair/img-17.png");
    }
    else if (itemName === "地漏") {
        return require("../../../assets/repair/img-18.png");
    }
    else{
        return require("../../../assets/repair/img-12.png");
    }
}

export default {
    getImg
}
